import { render, staticRenderFns } from "./UserDetailProjectsTile.vue?vue&type=template&id=996a2428&scoped=true&lang=pug&"
import script from "./UserDetailProjectsTile.vue?vue&type=script&lang=js&"
export * from "./UserDetailProjectsTile.vue?vue&type=script&lang=js&"
import style0 from "./UserDetailProjectsTile.vue?vue&type=style&index=0&id=996a2428&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "996a2428",
  null
  
)

export default component.exports